const ScriptLoader = {
  loadQueue: new Map(),
  scriptStatus: new Map(),

  async load(url, { priority = 'low', defer = true, async = false } = {}) {
    // Return existing promise if script is already loading/loaded
    if (this.loadQueue.has(url)) {
      return this.loadQueue.get(url);
    }

    // Create and store promise
    const promise = new Promise((resolve, reject) => {
      // Check if script is already in document
      if (this.scriptStatus.get(url) === 'loaded') {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = url;
      script.defer = defer;
      script.async = async;
      script.fetchPriority = priority;
      
      // Add performance monitoring
      const startTime = performance.now();
      
      script.onload = () => {
        const loadTime = performance.now() - startTime;
        this.scriptStatus.set(url, 'loaded');
        
        // Log performance data
        if (window.performance && window.performance.mark) {
          window.performance.mark(`script-loaded-${url}`);
          console.info(`Script ${url} loaded in ${loadTime}ms`);
        }
        
        resolve();
      };

      script.onerror = (error) => {
        this.scriptStatus.set(url, 'error');
        console.error(`Error loading script ${url}:`, error);
        reject(error);
      };
      
      document.body.appendChild(script);
    });
    
    this.loadQueue.set(url, promise);
    return promise;
  },

  // Load multiple scripts in order
  async loadSequential(urls, options = {}) {
    for (const url of urls) {
      await this.load(url, options);
    }
  },

  // Load multiple scripts in parallel
  async loadParallel(urls, options = {}) {
    return Promise.all(urls.map(url => this.load(url, options)));
  },

  // Preload scripts without executing
  preload(url) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'script';
    link.href = url;
    document.head.appendChild(link);
  }
};

// Make globally available
window.ScriptLoader = ScriptLoader;

// Initialize performance monitoring
if (window.performance && window.performance.mark) {
  window.performance.mark('script-loader-initialized');
}